<template>
    <section class="assessmentSection protectionLevelOverview aocIntroSection page-accessibility">
        <div class="welcomeBackground"></div>
        <div class="pageContent">
            <div class="pageCompleted">70% complete</div>
            <div class="pageTitle">It’s important to think about accessiblity</div>
            <div class="pageText">
                <p>
                    Accessible is a term we use to determine if someone can use the window to gain entry into a room or area from the outside. 
                </p>
            </div>
            <div class="interactiveImageSection">
              <img src="/img/aoc-explanation.png" class="interactiveImage" alt="" />

              <!-- Tag: Living Room -->
                <div class="tag groundLevel noFlex">
                    <div class="tagIcon" ref="iconGroundLevel"> <img src="/img/high-priority.png" /> </div>
                    <div class="tagLabel" ref="labelGroundLevel">
                        <div class="title">Ground level</div>
                        <p> Ground level windows can be reached. </p>
                    </div>
                </div>
                <!-- Tag: Basement -->
                <div class="tag climbing noFlex">
                    <div class="tagIcon" ref="iconClimbing"> <img src="/img/high-priority.png" /> </div>
                    <div class="tagLabel" ref="labelClimbing">
                        <div class="title">Climbing</div>
                        <p> If the window can be reached by climbing on top of something.</p>
                    </div>
                </div>
            </div>
            <continue-button to="/assessment/areas-of-concern-tips" text="Next" />
        </div>
    </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    computed: {
        ...mapState([])
    },
    methods: {
        ...mapActions([])
    },
    mounted() {
        setTimeout(() => { console.log(this.$refs); this.$refs['iconGroundLevel'].className += ' animated' }, 1000)
        setTimeout(() => { this.$refs['iconClimbing'].className += ' animated' }, 1250)
        setTimeout(() => { this.$refs['labelGroundLevel'].className += ' animated' }, 1500)
        setTimeout(() => { this.$refs['labelClimbing'].className += ' animated' }, 1750)
    }
}
</script>

<style lang="css"></style>
